import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_AUDIO_TYPES = ['audio/mpeg', 'audio/wav'];

export const modalFormSchema = z
  .object({
    lyrics: z.string().optional(),
    team_uuid: z.string().optional(),
    file: z.any().optional(),
  })
  .superRefine((values, ctx) => {
    if (!values?.file) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['anthem_file'],
        message: t('pages.application_history_anthem.schema.application_history_anthem_required_path'),
      });
    }

    if (!ACCEPTED_AUDIO_TYPES.includes(values?.file?.type)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['contract_file'],
        message: t('pages.application_history_anthem.schema.application_history_anthem_required_music'),
      });
    }
  });

export type ModalFormData = z.infer<typeof modalFormSchema>;
